import React, { useState } from "react";
import { Paper, Typography, Button, CircularProgress } from "@mui/material";
import { auth } from "../firebase";
import api from "../services/api";

export default function UpgradePrompt({ source = "unknown", title, subtitle }) {
  const user = auth.currentUser;
  const [loading, setLoading] = useState(false);

  const handleUpgrade = async () => {
    if (!user) return;
    setLoading(true);
    try {
      const res = await api.post("/stripe/create-checkout-session", {
        uid: user.uid,
        email: user.email,
        source,
        planType: "pro",
      });
      window.location.href = res.data.url;
    } catch (err) {
      console.error("Stripe session error:", err);
      setLoading(false); // only reset if error
    }
  };

  return (
    <Paper
      sx={{
        p: 3,
        mb: 4,
        border: "1px solid #fca5a5",
        backgroundColor: "#fef2f2",
      }}
    >
      <Typography variant="h6" color="error" gutterBottom>
        {title || "🚫 Feature unavailable"}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {subtitle ||
          "Your 14-day trial has ended. Upgrade to Pro to continue using this feature."}
      </Typography>
      <Button
        variant="contained"
        onClick={handleUpgrade}
        disabled={loading}
        sx={{ mt: 1 }}
      >
        {loading ? (
          <>
            <CircularProgress size={18} sx={{ mr: 1, color: "#fff" }} />
            Redirecting…
          </>
        ) : (
          "Upgrade to Pro"
        )}
      </Button>
    </Paper>
  );
}
